import { makeStyles } from '@mui/styles';
import IconButton from 'apollo-react/components/IconButton';
import CloseCircle from 'apollo-react-icons/CloseCircle';
import _ from 'lodash';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import AddNewControl from './AddNewControl';
import ChartTypePicker from './ChartTypePicker';
import ReportModelPickerModal from './ReportModelPickerModal';
import { addControl } from '../actions/report-designer.actions';
import { REPORT_CONTROL_TYPE } from '../constants/report-designer.constants';

const useStyles = makeStyles({
  pickerContainer: {
    position: 'relative',
    padding: '12px 24px',
    border: '1px dashed #0768fd',
    borderTop: '3px solid #0768fd',
    backgroundColor: '#ecf3ff',

    '& div[class*="MuiTextField"]': {
      maxWidth: 380,
      width: '100%',
    },
  },
  cancelBtn: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
});

const NewControl = ({ parentId, controlType, emptyControl = false }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [isModalOpen, setModalOpen] = useState(false);
  const [isChartPickerShown, setIsChartPickerShown] = useState(false);

  const reportModelFieldSelect = (mappingValues = {}) => {
    if (!_.isEmpty(mappingValues)) {
      setModalOpen(false);
      dispatch(addControl({ parentId, controlType, mappingValues }));
    }
  };

  const selectChartByType = (chartType) => {
    setIsChartPickerShown(false);
    dispatch(addControl({ parentId, controlType, mappingValues: { chartType } }));
  };

  const handleAddButtonClick = () => {
    if (controlType === REPORT_CONTROL_TYPE.CHART) {
      setIsChartPickerShown(true);
    } else if (emptyControl) {
      dispatch(addControl({ parentId, controlType }));
    } else {
      setModalOpen(true);
    }
  };

  return (
    <>
      {isChartPickerShown ? (
        <div className={classes.pickerContainer}>
          <ChartTypePicker onChange={selectChartByType} />
          <IconButton
            variant="primary"
            onClick={() => setIsChartPickerShown(false)}
            className={classes.cancelBtn}
          >
            <CloseCircle />
          </IconButton>
        </div>
      ) : (
        <AddNewControl controlType={controlType} onClick={handleAddButtonClick} />
      )}
      <ReportModelPickerModal
        open={isModalOpen}
        onClose={() => setModalOpen(false)}
        onChange={reportModelFieldSelect}
      />
    </>
  );
};

export default NewControl;
